import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/users/user6.jpg'
import _imports_1 from '@/assets/images/users/user13.jpg'
import _imports_2 from '@/assets/images/users/user14.jpg'
import _imports_3 from '@/assets/images/users/user15.jpg'
import _imports_4 from '@/assets/images/users/user16.jpg'
import _imports_5 from '@/assets/images/users/user17.jpg'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle" }
const _hoisted_4 = { class: "trezo-card-dropdown relative" }
const _hoisted_5 = { class: "trezo-card-content -mx-[20px] md:-mx-[25px]" }
const _hoisted_6 = { class: "table-responsive overflow-x-auto" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "text-black dark:text-white" }
const _hoisted_9 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_10 = { class: "rounded-full relative w-[40px] h-[40px]" }
const _hoisted_11 = {
  width: "50",
  height: "50",
  viewBox: "-25 -25 250 250",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "relative -top-[5px] ltr:-left-[5px] rtl:-right-[5px]",
  style: {"transform":"rotate(-90deg)"}
}
const _hoisted_12 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_13 = { class: "rounded-full relative w-[40px] h-[40px]" }
const _hoisted_14 = {
  width: "50",
  height: "50",
  viewBox: "-25 -25 250 250",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "relative -top-[5px] ltr:-left-[5px] rtl:-right-[5px]",
  style: {"transform":"rotate(-90deg)"}
}
const _hoisted_15 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_16 = { class: "rounded-full relative w-[40px] h-[40px]" }
const _hoisted_17 = {
  width: "50",
  height: "50",
  viewBox: "-25 -25 250 250",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "relative -top-[5px] ltr:-left-[5px] rtl:-right-[5px]",
  style: {"transform":"rotate(-90deg)"}
}
const _hoisted_18 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_19 = { class: "rounded-full relative w-[40px] h-[40px]" }
const _hoisted_20 = {
  width: "50",
  height: "50",
  viewBox: "-25 -25 250 250",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "relative -top-[5px] ltr:-left-[5px] rtl:-right-[5px]",
  style: {"transform":"rotate(-90deg)"}
}
const _hoisted_21 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_22 = { class: "rounded-full relative w-[40px] h-[40px]" }
const _hoisted_23 = {
  width: "50",
  height: "50",
  viewBox: "-25 -25 250 250",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "relative -top-[5px] ltr:-left-[5px] rtl:-right-[5px]",
  style: {"transform":"rotate(-90deg)"}
}
const _hoisted_24 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_25 = { class: "rounded-full relative w-[40px] h-[40px]" }
const _hoisted_26 = {
  width: "50",
  height: "50",
  viewBox: "-25 -25 250 250",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "relative -top-[5px] ltr:-left-[5px] rtl:-right-[5px]",
  style: {"transform":"rotate(-90deg)"}
}
const _hoisted_27 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_28 = { class: "rounded-full relative w-[40px] h-[40px]" }
const _hoisted_29 = {
  width: "50",
  height: "50",
  viewBox: "-25 -25 250 250",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "relative -top-[5px] ltr:-left-[5px] rtl:-right-[5px]",
  style: {"transform":"rotate(-90deg)"}
}
const _hoisted_30 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_31 = { class: "rounded-full relative w-[40px] h-[40px]" }
const _hoisted_32 = {
  width: "50",
  height: "50",
  viewBox: "-25 -25 250 250",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "relative -top-[5px] ltr:-left-[5px] rtl:-right-[5px]",
  style: {"transform":"rotate(-90deg)"}
}
const _hoisted_33 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_34 = { class: "rounded-full relative w-[40px] h-[40px]" }
const _hoisted_35 = {
  width: "50",
  height: "50",
  viewBox: "-25 -25 250 250",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "relative -top-[5px] ltr:-left-[5px] rtl:-right-[5px]",
  style: {"transform":"rotate(-90deg)"}
}
const _hoisted_36 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_37 = { class: "rounded-full relative w-[40px] h-[40px]" }
const _hoisted_38 = {
  width: "50",
  height: "50",
  viewBox: "-25 -25 250 250",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  class: "relative -top-[5px] ltr:-left-[5px] rtl:-right-[5px]",
  style: {"transform":"rotate(-90deg)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Performance of Agents")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500': true,
              active: _ctx.isActive,
            }),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }, [
              _createTextVNode(" Last 30 Days "),
              _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" })
            ], -1)
          ]), 2),
          _cache[2] || (_cache[2] = _createStaticVNode("<ul class=\"trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[10000] dark:bg-dark dark:shadow-none\"><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Day </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Week </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Month </button></li><li><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\"> This Year </button></li></ul>", 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[104] || (_cache[104] = _createElementVNode("thead", { class: "text-black dark:text-white" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " ID "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Agent Name "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Total Tickets "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Open Tickets "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Resolved Tickets "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Avg. Resolution Time "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Satisfaction Rate "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Availability "),
              _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Action ")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_8, [
            _createElementVNode("tr", null, [
              _cache[6] || (_cache[6] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #JAN-854 ")
              ], -1)),
              _cache[7] || (_cache[7] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Oliver Khan ")
                  ])
                ])
              ], -1)),
              _cache[8] || (_cache[8] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 230 ")
              ], -1)),
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 20 ")
              ], -1)),
              _cache[10] || (_cache[10] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 75 ")
              ], -1)),
              _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 2.5 hours ")
              ], -1)),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[4] || (_cache[4] = [
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      fill: "transparent",
                      stroke: "transparent",
                      "stroke-width": "16px",
                      "stroke-dasharray": "565.48px",
                      "stroke-dashoffset": "0"
                    }, null, -1),
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      stroke: "#605DFF",
                      "stroke-width": "16px",
                      "stroke-linecap": "round",
                      "stroke-dashoffset": "113px",
                      fill: "transparent",
                      "stroke-dasharray": "565.48px"
                    }, null, -1)
                  ]))),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[10px] absolute" }, " 80% ", -1))
                ])
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Available ")
              ], -1)),
              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-primary-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "View"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Edit"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-danger-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Delete"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[16] || (_cache[16] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #FEB-853 ")
              ], -1)),
              _cache[17] || (_cache[17] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Ava Cooper ")
                  ])
                ])
              ], -1)),
              _cache[18] || (_cache[18] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 180 ")
              ], -1)),
              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 16 ")
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 35 ")
              ], -1)),
              _cache[21] || (_cache[21] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 1.4 hours ")
              ], -1)),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_14, _cache[14] || (_cache[14] = [
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      fill: "transparent",
                      stroke: "transparent",
                      "stroke-width": "16px",
                      "stroke-dasharray": "565.48px",
                      "stroke-dashoffset": "0"
                    }, null, -1),
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      stroke: "#AD63F6",
                      "stroke-width": "16px",
                      "stroke-linecap": "round",
                      "stroke-dashoffset": "141px",
                      fill: "transparent",
                      "stroke-dasharray": "565.48px"
                    }, null, -1)
                  ]))),
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[10px] absolute" }, " 75% ", -1))
                ])
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Available ")
              ], -1)),
              _cache[23] || (_cache[23] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-primary-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "View"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Edit"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-danger-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Delete"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[26] || (_cache[26] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #MAR-852 ")
              ], -1)),
              _cache[27] || (_cache[27] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Isabella Evans ")
                  ])
                ])
              ], -1)),
              _cache[28] || (_cache[28] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 150 ")
              ], -1)),
              _cache[29] || (_cache[29] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 35 ")
              ], -1)),
              _cache[30] || (_cache[30] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 45 ")
              ], -1)),
              _cache[31] || (_cache[31] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 3.2 hours ")
              ], -1)),
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_17, _cache[24] || (_cache[24] = [
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      fill: "transparent",
                      stroke: "transparent",
                      "stroke-width": "16px",
                      "stroke-dasharray": "565.48px",
                      "stroke-dashoffset": "0"
                    }, null, -1),
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      stroke: "#25B003",
                      "stroke-width": "16px",
                      "stroke-linecap": "round",
                      "stroke-dashoffset": "113px",
                      fill: "transparent",
                      "stroke-dasharray": "565.48px"
                    }, null, -1)
                  ]))),
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[10px] absolute" }, " 80% ", -1))
                ])
              ]),
              _cache[32] || (_cache[32] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Available ")
              ], -1)),
              _cache[33] || (_cache[33] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-primary-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "View"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Edit"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-danger-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Delete"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[36] || (_cache[36] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #APR-851 ")
              ], -1)),
              _cache[37] || (_cache[37] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Mia Hughes ")
                  ])
                ])
              ], -1)),
              _cache[38] || (_cache[38] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 75 ")
              ], -1)),
              _cache[39] || (_cache[39] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 86 ")
              ], -1)),
              _cache[40] || (_cache[40] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 25 ")
              ], -1)),
              _cache[41] || (_cache[41] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 4.5 hours ")
              ], -1)),
              _createElementVNode("td", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_20, _cache[34] || (_cache[34] = [
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      fill: "transparent",
                      stroke: "transparent",
                      "stroke-width": "16px",
                      "stroke-dasharray": "565.48px",
                      "stroke-dashoffset": "0"
                    }, null, -1),
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      stroke: "#3584FC",
                      "stroke-width": "16px",
                      "stroke-linecap": "round",
                      "stroke-dashoffset": "0px",
                      fill: "transparent",
                      "stroke-dasharray": "565.48px"
                    }, null, -1)
                  ]))),
                  _cache[35] || (_cache[35] = _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[10px] absolute" }, " 100% ", -1))
                ])
              ]),
              _cache[42] || (_cache[42] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Available ")
              ], -1)),
              _cache[43] || (_cache[43] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-primary-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "View"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Edit"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-danger-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Delete"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[46] || (_cache[46] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #MAY-850 ")
              ], -1)),
              _cache[47] || (_cache[47] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Noah Mitchell ")
                  ])
                ])
              ], -1)),
              _cache[48] || (_cache[48] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 320 ")
              ], -1)),
              _cache[49] || (_cache[49] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 90 ")
              ], -1)),
              _cache[50] || (_cache[50] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 10 ")
              ], -1)),
              _cache[51] || (_cache[51] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 3.8 hours ")
              ], -1)),
              _createElementVNode("td", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_23, _cache[44] || (_cache[44] = [
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      fill: "transparent",
                      stroke: "transparent",
                      "stroke-width": "16px",
                      "stroke-dasharray": "565.48px",
                      "stroke-dashoffset": "0"
                    }, null, -1),
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      stroke: "#FD5812",
                      "stroke-width": "16px",
                      "stroke-linecap": "round",
                      "stroke-dashoffset": "0px",
                      fill: "transparent",
                      "stroke-dasharray": "565.48px"
                    }, null, -1)
                  ]))),
                  _cache[45] || (_cache[45] = _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[10px] absolute" }, " 100% ", -1))
                ])
              ]),
              _cache[52] || (_cache[52] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-danger-50 dark:bg-[#15203c] text-danger-500 rounded-sm font-medium text-xs" }, " Not Available ")
              ], -1)),
              _cache[53] || (_cache[53] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-primary-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "View"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Edit"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-danger-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Delete"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[56] || (_cache[56] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #JUN-849 ")
              ], -1)),
              _cache[57] || (_cache[57] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Sophia Carter ")
                  ])
                ])
              ], -1)),
              _cache[58] || (_cache[58] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 120 ")
              ], -1)),
              _cache[59] || (_cache[59] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 55 ")
              ], -1)),
              _cache[60] || (_cache[60] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 20 ")
              ], -1)),
              _cache[61] || (_cache[61] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 5.3 hours ")
              ], -1)),
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_26, _cache[54] || (_cache[54] = [
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      fill: "transparent",
                      stroke: "transparent",
                      "stroke-width": "16px",
                      "stroke-dasharray": "565.48px",
                      "stroke-dashoffset": "0"
                    }, null, -1),
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      stroke: "#605DFF",
                      "stroke-width": "16px",
                      "stroke-linecap": "round",
                      "stroke-dashoffset": "226px",
                      fill: "transparent",
                      "stroke-dasharray": "565.48px"
                    }, null, -1)
                  ]))),
                  _cache[55] || (_cache[55] = _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[10px] absolute" }, " 60% ", -1))
                ])
              ]),
              _cache[62] || (_cache[62] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Available ")
              ], -1)),
              _cache[63] || (_cache[63] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-primary-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "View"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Edit"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-danger-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Delete"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[66] || (_cache[66] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #JUL-852 ")
              ], -1)),
              _cache[67] || (_cache[67] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Isabella Evans ")
                  ])
                ])
              ], -1)),
              _cache[68] || (_cache[68] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 150 ")
              ], -1)),
              _cache[69] || (_cache[69] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 35 ")
              ], -1)),
              _cache[70] || (_cache[70] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 45 ")
              ], -1)),
              _cache[71] || (_cache[71] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 3.2 hours ")
              ], -1)),
              _createElementVNode("td", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_29, _cache[64] || (_cache[64] = [
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      fill: "transparent",
                      stroke: "transparent",
                      "stroke-width": "16px",
                      "stroke-dasharray": "565.48px",
                      "stroke-dashoffset": "0"
                    }, null, -1),
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      stroke: "#25B003",
                      "stroke-width": "16px",
                      "stroke-linecap": "round",
                      "stroke-dashoffset": "113px",
                      fill: "transparent",
                      "stroke-dasharray": "565.48px"
                    }, null, -1)
                  ]))),
                  _cache[65] || (_cache[65] = _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[10px] absolute" }, " 80% ", -1))
                ])
              ]),
              _cache[72] || (_cache[72] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Available ")
              ], -1)),
              _cache[73] || (_cache[73] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-primary-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "View"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Edit"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-danger-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Delete"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[76] || (_cache[76] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #AUG-851 ")
              ], -1)),
              _cache[77] || (_cache[77] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Mia Hughes ")
                  ])
                ])
              ], -1)),
              _cache[78] || (_cache[78] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 75 ")
              ], -1)),
              _cache[79] || (_cache[79] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 86 ")
              ], -1)),
              _cache[80] || (_cache[80] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 25 ")
              ], -1)),
              _cache[81] || (_cache[81] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 4.5 hours ")
              ], -1)),
              _createElementVNode("td", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_32, _cache[74] || (_cache[74] = [
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      fill: "transparent",
                      stroke: "transparent",
                      "stroke-width": "16px",
                      "stroke-dasharray": "565.48px",
                      "stroke-dashoffset": "0"
                    }, null, -1),
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      stroke: "#3584FC",
                      "stroke-width": "16px",
                      "stroke-linecap": "round",
                      "stroke-dashoffset": "0px",
                      fill: "transparent",
                      "stroke-dasharray": "565.48px"
                    }, null, -1)
                  ]))),
                  _cache[75] || (_cache[75] = _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[10px] absolute" }, " 100% ", -1))
                ])
              ]),
              _cache[82] || (_cache[82] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Available ")
              ], -1)),
              _cache[83] || (_cache[83] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-primary-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "View"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Edit"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-danger-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Delete"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[86] || (_cache[86] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #SEP-850 ")
              ], -1)),
              _cache[87] || (_cache[87] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Noah Mitchell ")
                  ])
                ])
              ], -1)),
              _cache[88] || (_cache[88] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 320 ")
              ], -1)),
              _cache[89] || (_cache[89] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 90 ")
              ], -1)),
              _cache[90] || (_cache[90] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 10 ")
              ], -1)),
              _cache[91] || (_cache[91] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 3.8 hours ")
              ], -1)),
              _createElementVNode("td", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_35, _cache[84] || (_cache[84] = [
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      fill: "transparent",
                      stroke: "transparent",
                      "stroke-width": "16px",
                      "stroke-dasharray": "565.48px",
                      "stroke-dashoffset": "0"
                    }, null, -1),
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      stroke: "#FD5812",
                      "stroke-width": "16px",
                      "stroke-linecap": "round",
                      "stroke-dashoffset": "0px",
                      fill: "transparent",
                      "stroke-dasharray": "565.48px"
                    }, null, -1)
                  ]))),
                  _cache[85] || (_cache[85] = _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[10px] absolute" }, " 100% ", -1))
                ])
              ]),
              _cache[92] || (_cache[92] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-danger-50 dark:bg-[#15203c] text-danger-500 rounded-sm font-medium text-xs" }, " Not Available ")
              ], -1)),
              _cache[93] || (_cache[93] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-primary-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "View"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Edit"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-danger-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Delete"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _cache[96] || (_cache[96] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #OCT-849 ")
              ], -1)),
              _cache[97] || (_cache[97] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-full w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "inline-block rounded-full",
                      alt: "user-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Sophia Carter ")
                  ])
                ])
              ], -1)),
              _cache[98] || (_cache[98] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 120 ")
              ], -1)),
              _cache[99] || (_cache[99] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 55 ")
              ], -1)),
              _cache[100] || (_cache[100] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 20 ")
              ], -1)),
              _cache[101] || (_cache[101] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 5.3 hours ")
              ], -1)),
              _createElementVNode("td", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_38, _cache[94] || (_cache[94] = [
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      fill: "transparent",
                      stroke: "transparent",
                      "stroke-width": "16px",
                      "stroke-dasharray": "565.48px",
                      "stroke-dashoffset": "0"
                    }, null, -1),
                    _createElementVNode("circle", {
                      r: "90",
                      cx: "100",
                      cy: "100",
                      stroke: "#605DFF",
                      "stroke-width": "16px",
                      "stroke-linecap": "round",
                      "stroke-dashoffset": "226px",
                      fill: "transparent",
                      "stroke-dasharray": "565.48px"
                    }, null, -1)
                  ]))),
                  _cache[95] || (_cache[95] = _createElementVNode("span", { class: "block text-gray-500 dark:text-gray-400 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[10px] absolute" }, " 60% ", -1))
                ])
              ]),
              _cache[102] || (_cache[102] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-primary-50 dark:bg-[#15203c] text-primary-500 rounded-sm font-medium text-xs" }, " Available ")
              ], -1)),
              _cache[103] || (_cache[103] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-primary-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "View"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Edit"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-danger-500 leading-none custom-tooltip",
                    id: "customTooltip",
                    "data-text": "Delete"
                  }, [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                  ])
                ])
              ], -1))
            ])
          ])
        ])
      ]),
      _createVNode(_component_Pagination, {
        items: "10",
        total: "36",
        class: "px-[20px] md:px-[25px] pt-[12px] md:pt-[14px]"
      })
    ])
  ]))
}